import React from 'react';
import DadMoments from './components/DadMoments';

const App: React.FC = () => {
  return (
    <div className="App">
      <DadMoments />
    </div>
  );
};

export default App; 